const serviceWorkerURL = '/sw.js';

export const backendless = {
    async start() {
        await navigator.serviceWorker.register(serviceWorkerURL, {
            scope: '/',
            type: 'module',
        });
        location.reload();
    },
    async end() {
        const registration = await navigator.serviceWorker.getRegistration(serviceWorkerURL);
        registration?.unregister();
        location.reload();
    },
};
